// MESS-10c, Betreiberfreigabe 03.11.2026: Meldung eines Zwischenschritts an POST /api/public/mess-stufe/{stufe}.
// Body nur die vier utm-Felder (kein gclid). Tab-Sperre im sessionStorage („stufe:weltId“, keine Person).
// Versand per fetch mit keepalive (übersteht den Seitenwechsel; Body-Grenze 64 KiB) und ohne Cookies;
// nie abgewartet, Fehler werden still verschluckt.
import { API } from "@/lib/api";
import { leseHerkunft } from "@/lib/herkunft";

const SPERRE = "clartext_mess_stufen";
const UTM_FELDER = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

const alsListe = (roh) => {
  try {
    const liste = JSON.parse(roh);
    return Array.isArray(liste) ? liste : [];
  } catch {
    return [];
  }
};

// true, wenn im Tab schon gemeldet; wirft der Speicher, wird ohne Sperre gesendet.
function schonGemeldet(eintrag) {
  try {
    const liste = alsListe(window.sessionStorage.getItem(SPERRE));
    if (liste.includes(eintrag)) return true;
    window.sessionStorage.setItem(SPERRE, JSON.stringify([...liste, eintrag]));
  } catch {
    /* Speicher blockiert: ohne Sperre senden */
  }
  return false;
}

export function meldeStufe(stufe, weltId) {
  if (schonGemeldet(`${stufe}:${weltId || "ohne"}`)) return;
  try {
    const herkunft = leseHerkunft() || {};
    const body = {};
    UTM_FELDER.forEach((feld) => {
      body[feld] = typeof herkunft[feld] === "string" ? herkunft[feld] : null;
    });
    fetch(`${API}/public/mess-stufe/${stufe}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  } catch {
    /* Meldung darf nie eine Seite oder einen Klick stören */
  }
}
